import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import AppImage from '~root/src/components/AppImage.vue?shadow'
window.customElements.define('otu-app-image', wrap(Vue, AppImage))

import CustomizerATC from '~root/src/components/CustomizerATC.vue?shadow'
window.customElements.define('otu-customizer-a-t-c', wrap(Vue, CustomizerATC))

import CustomizerDropdown from '~root/src/components/CustomizerDropdown.vue?shadow'
window.customElements.define('otu-customizer-dropdown', wrap(Vue, CustomizerDropdown))

import CustomizerPrice from '~root/src/components/CustomizerPrice.vue?shadow'
window.customElements.define('otu-customizer-price', wrap(Vue, CustomizerPrice))

import CustomizerQty from '~root/src/components/CustomizerQty.vue?shadow'
window.customElements.define('otu-customizer-qty', wrap(Vue, CustomizerQty))

import CustomizerRadio from '~root/src/components/CustomizerRadio.vue?shadow'
window.customElements.define('otu-customizer-radio', wrap(Vue, CustomizerRadio))

import CustomizerSizeDropdown from '~root/src/components/CustomizerSizeDropdown.vue?shadow'
window.customElements.define('otu-customizer-size-dropdown', wrap(Vue, CustomizerSizeDropdown))

import CustomizerStringDropdown from '~root/src/components/CustomizerStringDropdown.vue?shadow'
window.customElements.define('otu-customizer-string-dropdown', wrap(Vue, CustomizerStringDropdown))

import CustomizerVariantDropdown from '~root/src/components/CustomizerVariantDropdown.vue?shadow'
window.customElements.define('otu-customizer-variant-dropdown', wrap(Vue, CustomizerVariantDropdown))

import DropdownWrapper from '~root/src/components/DropdownWrapper.vue?shadow'
window.customElements.define('otu-dropdown-wrapper', wrap(Vue, DropdownWrapper))

import FabricModal from '~root/src/components/FabricModal.vue?shadow'
window.customElements.define('otu-fabric-modal', wrap(Vue, FabricModal))

import FabricSelector from '~root/src/components/FabricSelector.vue?shadow'
window.customElements.define('otu-fabric-selector', wrap(Vue, FabricSelector))

import HelloWorld from '~root/src/components/HelloWorld.vue?shadow'
window.customElements.define('otu-hello-world', wrap(Vue, HelloWorld))

import ImagePicker from '~root/src/components/ImagePicker.vue?shadow'
window.customElements.define('otu-image-picker', wrap(Vue, ImagePicker))

import ProductCustomizer from '~root/src/components/ProductCustomizer.vue?shadow'
window.customElements.define('otu-product-customizer', wrap(Vue, ProductCustomizer))

import TemplatedController from '~root/src/components/TemplatedController.vue?shadow'
window.customElements.define('otu-templated-controller', wrap(Vue, TemplatedController))

import VariableATC from '~root/src/components/VariableATC.vue?shadow'
window.customElements.define('otu-variable-a-t-c', wrap(Vue, VariableATC))

import VariableController from '~root/src/components/VariableController.vue?shadow'
window.customElements.define('otu-variable-controller', wrap(Vue, VariableController))